import React, { useState } from "react"
import { ColorModeContext } from "../theme/theme"
import {
	AppBar,
	Drawer,
	IconButton,
	List,
	ListItem,
	ListItemButton,
	ListItemIcon,
	ListItemText,
	Toolbar,
	Typography,
} from "@mui/material"
import MenuIcon from "@mui/icons-material/Menu"
import LightModeIcon from "@mui/icons-material/LightMode"
import HomeIcon from "@mui/icons-material/Home"
import ContactsIcon from "@mui/icons-material/Contacts"
import HelpCenterIcon from "@mui/icons-material/HelpCenter"
import { useNavigate } from "react-router-dom"

const NavBarMob = () => {
	const navigate = useNavigate()
	const colorMode = React.useContext(ColorModeContext)
	const [open, setOpen] = useState<boolean>(false)

	const handleClick = (path: string) => {
		setOpen(false)
		navigate(path)
	}

	return (
		<AppBar position="static" sx={{ marginBottom: "10px" }}>
			<Toolbar>
				<IconButton
					size="large"
					edge="start"
					color="inherit"
					aria-label="menu"
					sx={{ mr: 2 }}
					onClick={() => setOpen((prev) => !prev)}
				>
					<MenuIcon />
				</IconButton>
				<Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
					ГЕОЗЕМПЛАН
				</Typography>
				<IconButton
					size="large"
					edge="start"
					color="inherit"
					aria-label="menu"
					sx={{ mr: 2 }}
					onClick={colorMode.toggleColorMode}
				>
					<LightModeIcon />
				</IconButton>
			</Toolbar>
			<Drawer anchor={"left"} open={open} onClose={() => setOpen(false)}>
				<List>
					<ListItem disablePadding>
						<ListItemButton onClick={() => handleClick("/home")}>
							<ListItemIcon>
								<HomeIcon />
							</ListItemIcon>
							<ListItemText primary={"Главная"} />
						</ListItemButton>
					</ListItem>
					<ListItem disablePadding>
						<ListItemButton onClick={() => handleClick("/contacts")}>
							<ListItemIcon>
								<ContactsIcon />
							</ListItemIcon>
							<ListItemText primary={"Контакты"} />
						</ListItemButton>
					</ListItem>
					<ListItem disablePadding>
						<ListItemButton onClick={() => handleClick("/faq")}>
							<ListItemIcon>
								<HelpCenterIcon />
							</ListItemIcon>
							<ListItemText primary={"F.A.Q"} />
						</ListItemButton>
					</ListItem>
				</List>
			</Drawer>
		</AppBar>
	)
}

export default NavBarMob
